import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'

@Component({
  selector: 'ddc-expand-btn',
  templateUrl: './ddc-expand-btn.component.html',
  styleUrls: ['./ddc-expand-btn.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule],
})
export class DdcExpandBtnComponent {
  @Input() expanded = false
  @Input() disabled = false
  @Input() tooltip: string = undefined
  @Output() expandedChange = new EventEmitter<boolean>()

  toggle(): void {
    if (!this.disabled) {
      this.expanded = !this.expanded
      this.expandedChange.emit(this.expanded)
    }
  }
}
